var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInsured(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 50,
    viewBox: "0 0 60 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    fill: "#628DCD"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.9 40.2v-1.9c-.3-3.2 1-5.9 3.6-7.6l.4-.9 1.5-3.8a11.2 11.2 0 0 1 9.4-7.1v-11c0-1-.5-1.6-1.7-1.7h-1C27.7 6 23 4.4 19.2.8c-1-1-1.7-1-2.8 0a19.6 19.6 0 0 1-5 3.4c-3 1.4-6.2 2-9.5 2-1.5 0-2 .5-2 2v5.4a51 51 0 0 0 .5 9.6C2 32 6.5 38 14.5 41.5c4 1.7 2.9 1.7 6.4.2v-1.5Zm-3.4-13.6c-1.2 1.3-2 1.4-3.3.2L9.3 22l-.6-.6 2.4-2.5 4.7 4.4 8.8-9.8 2.7 2.5-9.8 10.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.2 37.4a4 4 0 0 0-1.3-3.1l-2-1.6-2.3-5.7c-1.3-2.9-3.5-4.6-6.7-4.7-3.4-.2-6.8 0-10.2 0a6 6 0 0 0-1.2 0l-.4.1a8 8 0 0 0-5.7 5l-2.1 5.4C25 34 24 35.6 24.3 38v2.2a5 5 0 0 0 .8 3.1c.3.4.4.8.4 1.3v2.8c.2 1.6 1 2.6 2.7 2.6h2c1.5 0 2.3-1 2.4-2.5v-2c1-.2 16.8-.3 18.2 0l.1 2c0 1.5 1 2.4 2.4 2.4h2.1c1.7 0 2.5-.9 2.6-2.5v-3.7c1-1 1.2-2.4 1.2-3.7v-2.6Zm-25.6 2.4c-.4.5-.8.8-1.4.7H30c-.9 0-1.5-.4-1.8-1.2-.3-1-.1-2 .6-2.6a2 2 0 0 1 2.3-.3c1 .5 2.6 2 2.5 3.4Zm5.2-7.2h-6.2c.6-1.4 1-2.7 1.6-3.8.3-.7.9-1.3 1.7-1.5l2.3-.3h7.6c2-.1 3.1.7 3.7 2.4l1.3 3c-2 .2-4 .1-6 .2h-6ZM54 40.3c-1 .2-2 .2-3 0-1 0-1.3-.7-.9-1.6.6-1.3 1.6-2.3 3.2-2.5 1-.2 1.9.4 2.2 1.5.4 1.4 0 2.4-1.5 2.6Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h59.2v50H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsured);
export default __webpack_public_path__ + "static/media/Insured.cadb54c1b981b8f4cd395acb880bcfba.svg";
export { ForwardRef as ReactComponent };